import { apiCall } from ".";

export const activeLoanMetricApi = () => {
  return apiCall(true).get("/metrics/active-loans");
};

export const activeInvestmentMetricApi = () => {
  return apiCall(true).get("/metrics/active-investments");
};

export const nextLoanRepaymentApi = () => {
  return apiCall(true).get("/metrics/next-loan-repayment");
};

export const nextInvestmentRepaymentApi = () => {
  return apiCall(true).get("/metrics/next-investment-repayment");
};
